import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
// import LightBox from '@bd/bdui-lightbox';
import PageWrapper from '../../components/PageWrapper';
import Breadcrumbs from '../../components/Breadcrumbs';
import DetailPageWrapper from '../../components/DetailPageWrapper';
import PlanCardOptions from '../../components/PlanCardOptions';
import DetailHeader from './DetailHeader';
import DetailMenu from './DetailMenu';
import Overview from './Overview';
import Description from './Description';
import Elevations from './Elevations';
import FloorPlan from './FloorPlan';
import PhotoGallery from './PhotoGallery';
import Specifications from './Specifications';
import Schools from './Schools';
import Map from './Map';
import Disclaimer from './Disclaimer';
import { colors } from '../../styles';

const styles = css`
  .planSeriesOptions {
    margin: 20px 10px;
    padding: 0px;
  }
  .planSeriesOptions-active {
    border: 4px solid ${colors.brand3Light};
  }
`;

function PlanLibraryDetail({ plan, community, agents, plans }) {
  const parentId = plan.is_parent_plan ? plan._id : plan.parent_plan_select;
  const series = orderBy(plans.filter(item => (item.parent_plan_select === parentId)), 'name');
  const parentPlan = find(plans, item => item._id === parentId);
  return (
    <PageWrapper>
      <PageHelmet plan={plan} />
      <DetailPageWrapper>
        <Breadcrumbs plan={plan} />
        <DetailHeader plan={plan} />
        <DetailMenu plan={plan} />
        {
          get(plan, 'parent_plan_select') &&
          <div className={styles}>
            <div className="PlanLibraryDetail__planOptions">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-12 mt-5">
                    <h4 className="DetailContactBanner_title">
                      Choose An Elevation
                    </h4>
                  </div>
                  <div className="col-12">
                    <div className="row justify-content-center">
                      {
                        series.map(seriesItem => (
                          <div className={`col-lg-6 col-xl-3 planSeriesOptions ${seriesItem._id === plan._id ? 'planSeriesOptions-active' : ''}`} key={seriesItem._id}>
                            <PlanCardOptions plan={seriesItem} />
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <Overview plan={plan || parentPlan} community={community} agents={agents} />
        <Description plan={plan || parentPlan} />
        <Elevations plan={plan || parentPlan} />
        <FloorPlan plan={plan || parentPlan} />
        <PhotoGallery plan={plan || parentPlan} />
        <Specifications plan={plan || parentPlan} />
        <Schools community={community} />
        <Map plan={plan || parentPlan} />
        <Disclaimer plan={plan || parentPlan} />
      </DetailPageWrapper>
    </PageWrapper>
  );
}

PlanLibraryDetail.propTypes = {
  plan: PropTypes.object.isRequired,
  community: PropTypes.object,
  agents: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.object,
};

PlanLibraryDetail.defaultProps = {
  community: undefined,
  plans: undefined,
  agents: [],
};

export default withData(
  {
    community: true,
    plans: true,
    plan: true,
    agents: true,
  },
  {
    required: {
      plan: true,
    },
    ifMissing404: true,
  },
)(PlanLibraryDetail);



// WEBPACK FOOTER //
// ./src/pages/PlanLibraryDetail/index.js